import { render, staticRenderFns } from "./Ad_Detail.vue?vue&type=template&id=1d18e7a9&scoped=true&"
import script from "./Ad_Detail.vue?vue&type=script&lang=js&"
export * from "./Ad_Detail.vue?vue&type=script&lang=js&"
import style0 from "./Ad_Detail.vue?vue&type=style&index=0&id=1d18e7a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18e7a9",
  null
  
)

export default component.exports